import { defineComponent as _defineComponent } from 'vue'
import { ref, defineAsyncComponent } from 'vue';
import ModalCenter from '../modal-center/modal-center.vue';
import { useScreenSize } from '@white-label-helper/shared-composables';

interface Props {
  closeButtonId?: string;
  closeOnClickOutside?: boolean;
  showCloseIcon?: boolean;
  modalClasses?: string;
  propClass?: string;
  isStickyHeaderTransparent?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'modal-scrollable-body',
  props: {
    closeButtonId: { default: '' },
    closeOnClickOutside: { type: Boolean, default: false },
    showCloseIcon: { type: Boolean, default: false },
    modalClasses: { default: '' },
    propClass: { default: '' },
    isStickyHeaderTransparent: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { closeButtonId: string, closeOnClickOutside: boolean, showCloseIcon: boolean, modalClasses: string, propClass: string, isStickyHeaderTransparent: boolean };


const IconClose = defineAsyncComponent(() =>
  import('@white-label-icon/icon-close')
);



const scrollAtTheTop = ref(true);
const hideScrollBarUnderHeader = ref(true);

const scrollArea = ref<HTMLElement | null>(null);
const scrollAreaBody = ref<HTMLElement | null>(null);

const { isLargeDesktopResolution } = useScreenSize();

const scrollListener = () => {
  const element = scrollArea.value as HTMLElement;
  scrollAtTheTop.value = element.scrollTop === 0;
};

const toggleScrollBarVisibility = () => {
  // Put to end of event loop
  setTimeout(() => {
    if (scrollAreaBody.value) {
      const scrollAreaBodyElement: HTMLElement = scrollAreaBody.value as HTMLElement;
      const scrollBarHeight = scrollAreaBodyElement.scrollHeight - scrollAreaBodyElement.clientHeight;
      hideScrollBarUnderHeader.value = scrollBarHeight > 0;
    }
  }, 0);
};


return { __sfc: true,IconClose, props, scrollAtTheTop, hideScrollBarUnderHeader, scrollArea, scrollAreaBody, isLargeDesktopResolution, scrollListener, toggleScrollBarVisibility, ModalCenter }
}

})